var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 30,
  viewBox: "0 0 23 37"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M11.201 36.189A7.207 7.207 0 0 1 7.528 22.78V1.151c0-.203.164-.367.367-.367h6.612c.203 0 .367.164.367.367v21.63a7.215 7.215 0 0 1-3.673 13.408zM8.248 1.519v21.475a.353.353 0 0 1-.191.315 6.48 6.48 0 1 0 6.296 0 .353.353 0 0 1-.191-.315V1.518H8.248z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M11.201 33.58a4.665 4.665 0 0 1-2.057-8.816V4.296c0-.203.164-.368.367-.368h3.387c.203 0 .368.165.368.368v20.431a4.665 4.665 0 0 1-2.065 8.817v.036zM9.879 4.663v20.3c-.001.148-.091.281-.228.337a3.93 3.93 0 1 0 3.1 0 .375.375 0 0 1-.22-.337v-20.3H9.879z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.509 15.198h-3.1a.367.367 0 1 1 0-.734h3.004l15.671-9.272a.316.316 0 0 1 .184-.052h2.733c.203 0 .367.165.367.368a.375.375 0 0 1-.367.367h-2.63L3.714 15.147a.353.353 0 0 1-.205.051z"
}))));
export default __webpack_public_path__ + "teg/media/temp-sensitive.2a2dd459.svg";
export { SvgComponent as ReactComponent };